module.exports = __webpack_public_path__ + "img/placeholder16x9.ecaac6d0.png";